<template lang="pug">
v-container.pa-8(fluid)
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text Patient database
  v-row.pb-2.pb-md-0(no-gutters)
    //- Top Tabs
    template(v-if="selectedPatients.length")
      v-col(cols="12" md="6")
        .d-flex.align-center.ml-5.mt-2.pb-1
          template(v-if="!isSelectionMode")
            v-btn.button-Aa-small.mr-3.px-3(v-if="segmentTab === 0" @click="onDelete" color="danger500" height=32 outlined depressed) {{ $t('delete') }}
            v-btn.button-Aa-small.mr-3.px-3(v-else-if="!segments[segmentTab].dynamic" color="danger500" height=32 outlined depressed @click="showSegmentRemovePatientDialog = true") Remove from segment
            v-btn.button-Aa-small.mr-3.px-3(v-if="!segments[segmentTab].dynamic" @click="onAddSegment" color="primary" outlined height=32 depressed) {{ $t('add_to_segment') }}
            v-btn.button-Aa-small.mr-3.px-3(@click="onSendSms" color="primary" outlined height=32 depressed) {{ $t('send_sms') }}
            v-btn.button-Aa-small.mr-3.px-3(@click="onSendEmail" color="primary" outlined height=32 depressed) {{ $t('send_email') }}
          template(v-else)
            v-btn.button-Aa-small.mr-3.px-3(v-if="isSelectionMode" color="primary" outlined height=32) ({{ selectedPatients.length }}) {{ $t('added') }}
          a.link-s(@click="clearSelection") {{ $t('clear_selection') }}
    template(v-else)
      v-col(cols="12" md="9")
        div.d-flex.align-center.my-5(v-if="isFetchingSegment")
          v-progress-linear(:width="3" rounded color="primary" indeterminate)
        v-tabs(v-else v-model="segmentTab" color="basic700" :height="44" :grow="isMobileScreen" show-arrows active-class="font-semibold" @change="tabChanged")
          v-tab.px-0(v-for="segment in segments" :key="segment.id")
            div(v-if="tabShowMenu(segment)")
              v-menu(v-if="showMenu" offset-y rounded="lg")
                template(#activator="{ on }")
                  v-btn.text-sm.font-medium.text-none(text small v-on="on") {{ segment.title }} ({{ segment.customer_count }})
                    v-icon(right size="20" color="neutral700") $yzi-chevron-down
                v-list.py-0
                  v-list-item(@click="showEditSegmentDialog = true")
                    v-list-item-title
                      div.d-flex.align-center
                        v-icon.mr-2(color="neutral700" size="18") $yzi-text-input
                        div.text-sm.neutral700--text Rename
                  template(v-if="segment.dynamic")
                    v-divider
                    v-list-item(@click="openDynamicFilter")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-2(color="neutral700" size="18") $yzi-data-flow-01
                          div.text-sm.neutral700--text Edit dynamic filters
                  template(v-else)
                    v-divider
                    v-list-item(@click="showCustomerSegmentDialog = true")
                      v-list-item-title
                        div.d-flex.align-center
                          v-icon.mr-2(color="neutral700" size="18") $yzi-users-plus
                          div.text-sm.neutral700--text Add customers
                  v-divider
                  v-list-item(@click="showDuplicateSegmentDialog = true")
                    v-list-item-title
                      div.d-flex.align-center
                        v-icon.mr-2(color="neutral700" size="18") $yzi-copy-03
                        div.text-sm.neutral700--text Duplicate
                  v-divider
                  v-list-item(@click="showDeleteSegmentDialog = true")
                    v-list-item-title
                      div.d-flex.align-center
                        v-icon.mr-2(color="danger500" size="18") $yzi-trash-03
                        div.text-sm.danger500--text Delete

              div.text-sm.font-medium.text-none(v-else style="padding: 0 26px 0 26px;") {{ segment.title }} ({{ segment.customer_count }})
            div.text-sm.font-medium.text-none.px-4(v-else) {{ segment.title }}
              span.ml-1(v-if="segment.id !== 'all'") ({{ segment.customer_count }})
          v-btn.my-auto(icon small color="transparent" @click="showAddSegmentDialog = true")
            v-icon(color="neutral700" size="23") mdi-plus

    v-col(cols="12" :md="selectedPatients.length ? 6 : 3" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(v-if="!showSearchField" icon @click="showAddSegmentDialog = true")
          v-icon(color="neutral700" size="23") mdi-plus
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
        div(v-if="!showSearchField")
          customize-column-menu(type="patient" :showTooltip="false" iconSize="21")
            template(#prepend-list)
              div.d-flex.align-center.px-6
                .text-md.font-semibold Database Settings
                v-spacer
                y-button(label="Edit" underline size="sm" unset-min-width button-class="px-0" @click="showDatabaseSettingDialog = true")
              v-divider.mt-2

        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addContact") {{ $t('add_patient') }}
  //- Filter
  dynamic-filter-row(v-if="showDynamicFilters" :segment.sync="selectedSegment" @updated="updateDynamicFilter" @closed="showDynamicFilters = false")
  patients-filter-row.my-4(v-else ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
  .data-table
    v-data-table.table-custom.mt-sm-4.pb-6(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(v-slot:no-data)
        div.mt-16(v-if="selectedSegment && selectedSegment.dynamic" )
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
        div.empty-box.mt-6.pa-8(v-else-if="!isFetching && !isFetchingSegment && !filters.length" align="center")
          v-avatar(color="neutral300" size="54")
            v-icon(color="neutral500" size="36") $yzi-users-02
          div.text-center.text-md.font-semibold.neutral700--text.mt-6 Start adding customers into this segment
          y-button.mt-4(label="Add customer" prepend-icon="$yzi-plus" size="sm" @click="showCustomerSegmentDialog = true")
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:header.phone)
        span {{ 'phone' | fieldNameDisplay }}
      template(v-slot:header.total_paid)
        span {{ 'total_paid' | fieldNameDisplay }}
      template(v-slot:header.marital_status)
        span {{ 'marital_status' | fieldNameDisplay }}
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text
          template(v-for="header in headers" )
            td(@click="viewPatientInfo(header, item)")
              template(v-if="header.value === 'checked'")
                yc-checkbox(v-model="item.checked" @change="onChecked")
              template(v-else-if="header.value === 'name'")
                div(:id="`pt-${index}`" style="position: relative;")
                div.d-flex.my-3
                  div(style="width: 30px;")
                    v-responsive(:aspect-ratio="7/10" style="width: 30px;")
                      v-card.fill-height(v-if="item.profile_image && item.profile_image.file" flat)
                        v-img(:src="`https://img.yezza.io/50x50/${item.profile_image.path}`" height="100%" width="100%")
                          template(v-slot:placeholder)
                            v-row(class="fill-height ma-0" align="center" justify="center")
                              v-progress-circular(indeterminate color="grey")
                      v-card.neutral300.fill-height(v-else flat)
                        div.d-flex.align-center.justify-center.fill-height
                          v-icon(size="20") $yzi-user-03
                  div.pl-2
                    v-tooltip(top color="black" :attach="`#pt-${index}`" content-class="black tooltip-top-arrow")
                      template(#activator="{ on, attrs }")
                        div(v-bind="attrs" v-on="on")
                          .text-sm.font-semibold.neutral700--text.ellipsis-text-1 {{ item.name }}
                      div(style="max-width: 600px;")
                        .text-sm.font-semibold {{ item.name }}
                        .text-xs(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
                    div.d-flex.align-center
                      y-chip.mr-2(v-if="item.urgent" label="Urgent" size="xs" color="red")
                      .text-xs.neutral700--text.no-wrap(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
              template(v-else-if="header.value === 'total_paid'")
                .div {{ item.total_paid | displayPrice }}
              template(v-else-if="header.value === 'created'")
                div.text-xs.font-bold {{ (item.record_date || item.created) | humanizeDate }}
                div.text-xs {{ (item.record_date || item.created) | displayTime2 }}
              template(v-else-if="header.value === 'email'")
                div.break-all {{ item.email }}
              template(v-else-if="header.value === 'gender'")
                div {{ item.gender | capitalize }}
              template(v-else-if="header.value === 'race'")
                div {{ item.race | capitalize }}
              template(v-else-if="header.value === 'religion'")
                div {{ item.religion | capitalize }}
              template(v-else-if="header.value === 'emergency'")
                div.text-xs {{ item.emergency_contact.name || null }}
                div.text-xs {{ item.emergency_contact.phone || null }}
              template(v-else-if="header.value === 'marital_status'")
                div {{ item.marital_status | capitalize }}
              template(v-else-if="header.value === 'address'")
                div(:id="`adr-${index}`" style="position: relative;")
                div(v-if="item.address")
                  v-tooltip(top color="black" :attach="`#adr-${index}`" content-class="black tooltip-top-arrow")
                    template(#activator="{ on, attrs }")
                      .text-sm.neutral700--text.cursor-help(v-if="item.address.city" v-bind="attrs" v-on="on") {{ item.address.city }}
                    div.text-xs {{ getAddressInString(item.address) }}
              template(v-else-if="header.value === 'actions'")
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editPatient(item)")
                      v-list-item-title.text-sm.basic800--text Edit patient detail
                    v-divider
                    v-list-item(@click="openMergePatientDialog(item)")
                      v-list-item-title.text-sm.basic800--text Merge contact
                    v-divider
                    v-list-item(@click="openWhatsapp(item)")
                      v-list-item-title.text-sm.basic800--text Message via WhatsApp
              template(v-else)
                div {{ getFieldData(header.value, item) }}

  div.d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    add-patient(v-if="showAddPatientDialog" :open.sync="showAddPatientDialog" :selectedPatient="selectedPatient" @closed="closed($event)")
    add-segment-dialog(v-if="showAddSegmentDialog" :open.sync="showAddSegmentDialog" @updated="fetchSegments")
    add-to-segment-dialog(v-if="showAddToSegmentDialog" :open.sync="showAddToSegmentDialog" :customers="selectedPatients" @addNewSegment="fetchSegments" @success="successAddCustomer")
    edit-segment-dialog(v-if="showEditSegmentDialog" :open.sync="showEditSegmentDialog" :segment="selectedSegment" @updated="fetchSegments")
    duplicate-segment-dialog(v-if="showDuplicateSegmentDialog" :open.sync="showDuplicateSegmentDialog" :segment="selectedSegment" @updated="fetchSegments")
    customer-segment-dialog(v-if="showCustomerSegmentDialog" :open.sync="showCustomerSegmentDialog" :segment="selectedSegment" @updated="reset")
    delete-customer-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :customers="selectedPatients" @deleted="successDeleteCustomer")
    delete-segment-dialog(v-if="showDeleteSegmentDialog" :open.sync="showDeleteSegmentDialog" :segment="selectedSegment" @deleted="fetchSegments")
    segment-remove-patient-dialog(v-if="showSegmentRemovePatientDialog" :open.sync="showSegmentRemovePatientDialog" :segment="selectedSegment" :customers="selectedPatients" @deleted="successRemoveSegmentCustomer")
    merge-patient-dialog(v-if="showMergeDialog" :open.sync="showMergeDialog" :selectedPatient="selectedPatient" @merged="fetchCustomers" @close="closed('cancel')")
    database-setting-dialog(v-if="showDatabaseSettingDialog" :open.sync="showDatabaseSettingDialog" @closed="fetchCustomFields")
    y-dialog(v-if="showAddCustomerDialog" v-model="showAddCustomerDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-title.px-4 
          v-spacer 
          .text-xl.font-bold.ml-10 {{ $t('add_patient') }}
          v-spacer
          v-btn(icon @click="showAddCustomerDialog = false")
            v-icon mdi-close
        v-divider.mb-6 
        v-card-text.pt-4.pb-16.primary--text
          .pb-4
            .text-lg.font-medium.mb-2 Select your source of contact
            .text-md Choose one and click "Confirm"
          v-item-group(mandatory @change="onChanged" flat)
            div(v-for="option in addContactOptions" :key="option.id")
              v-item(v-slot="{ active, toggle }")
                .round-xl.mt-4.pa-4(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
                  .text-lg.font-medium.mb-1 {{ option.title }}
                  .text-sm.neutral500--text {{ option.description }}
        v-divider
        v-card-actions.px-6.py-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="showAddCustomerDialog = false")
          v-spacer
          y-button(label="Confirm" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="confirmAddContact")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import PatientsFilterRow from '@/components/clinic/patient/filters/PatientsFilterRow.vue'
import DynamicFilterRow from '@/components/clinic/patient/filters/DynamicFilterRow.vue'
import AddPatient from '@/components/clinic/patient/AddPatient.vue'
import AddSegmentDialog from '@/components/clinic/patient/AddSegmentDialog.vue'
import AddToSegmentDialog from '@/components/clinic/patient/AddToSegmentDialog.vue'
import EditSegmentDialog from '@/components/clinic/patient/EditSegmentDialog.vue'
import DuplicateSegmentDialog from '@/components/clinic/patient/DuplicateSegmentDialog.vue'
import SegmentRemovePatientDialog from '@/components/clinic/dialogs/SegmentRemovePatientDialog.vue'
import CustomerSegmentDialog from '@/components/clinic/patient/CustomerSegmentDialog.vue'
import DeleteCustomerDialog from '@/components/connect/dialogs/DeleteCustomerDialog.vue'
import DeleteSegmentDialog from '@/components/clinic/patient/DeleteSegmentDialog.vue'
import MergePatientDialog from '@/components/clinic/dialogs/MergePatientDialog.vue'
import DatabaseSettingDialog from '@/components/clinic/patient/DatabaseSettingDialog.vue'

export default {
  name: 'Patients',
  components: {
    MergePatientDialog,
    CustomizeColumnMenu,
    DeleteCustomerDialog,
    AddToSegmentDialog,
    AddSegmentDialog,
    EditSegmentDialog,
    DuplicateSegmentDialog,
    AddPatient,
    SegmentRemovePatientDialog,
    PatientsFilterRow,
    DynamicFilterRow,
    DeleteSegmentDialog,
    CustomerSegmentDialog,
    DatabaseSettingDialog
  },
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    loading: {
      type: Boolean,
      default: false
    },
    previousCustomers: {
      type: Array,
      default: null
    },
    savePage: {
      default: null
    },
    saveTab: {
      default: null
    },
    saveSearch: {
      default: null
    },
    saveFilters: {
      default: null
    },
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    isDeleting: false,
    isFetchingSegment: true,
    isMounted: false,
    showDeleteDialog: false,
    showDeleteSegmentDialog: false,
    showAddToSegmentDialog: false,
    showAddSegmentDialog: false,
    showEditSegmentDialog: false,
    showDuplicateSegmentDialog: false,
    showAddCustomerDialog: false,
    showAddPatientDialog: false,
    showSegmentRemovePatientDialog: false,
    showCustomerSegmentDialog: false,
    showMergeDialog: false,
    showDatabaseSettingDialog: false,
    showDynamicFilters: false,
    showSearchField: false,
    showMenu: false,
    checkAll: false,
    selectedPatient: null,
    selectedAddContactOption: null,
    selectedSegment: null,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    segmentTab: 0,
    customers: [],
    selectedPatients: [],
    filters: [],
    addContactOptions: [
      { 
        id: 'single', 
        title: 'Add single patient', 
        description: 'Manually add a contact by filling up required field' 
      },
      { 
        id: 'csv', 
        title: 'Upload CSV', 
        description: 'Import your patients by uploading the completed csv. file template' 
      }
    ],
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    segments: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      fields: 'clinic/getPatientFields'
    }),
    headers () {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false
      }
      const name = {
        text: 'Name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      const actions = {
        text: '',
        value: 'actions',
        class: 'text-table-header'
      }
      return [checkbox, name, ...filteredOptions, actions]
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize () {
      this.fetchFirstPage()
    },
    filters: {
      deep: true,
      handler () {
        this.selectedPatients = []
        if (this.isMounted) {
          this.fetchCustomers()
        } else {
          this.fetchFirstPage()
        }
      }
    },
    // segmentTab (value) {
    //   if (value) {
    //     this.selectedSegment = this.segments[value]
    //   } else {
    //     this.selectedSegment = null
    //   }
    //   this.selectedPatients = []
    //   this.currentPage = 1
    //   this.showDynamicFilters = false
    //   this.fetchCustomers()
    //   this.checkMenu()
    // }
  },
  mounted () {
    this.checkSaveSearchPage()
    this.fetchCustomFields()
    this.fetchSegments(true)
    if (!this.saveTab && !this.saveFilters) {
      this.fetchCustomers()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCustomers() {
      this.isFetching = true
      let endpoint = `/clinics/${this.company.slug}/patients`
      let params = {
        page_size: this.pageSize,
        page: this.currentPage
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      if (this.selectedSegment) {
        params.groups = this.selectedSegment.id
      }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(endpoint, { params })
        .then(resp => {
          let data = resp.data
          let customers = data.results
          customers.map(item => {
            item.checked = false
            if (this.previousCustomers) {
              if (this.previousCustomers.includes(item.id)) {
                item.checked = true
              }
            }
            if (!item.age && item.dob) {
              item.age = this.getAge(item.dob)
            }
          })
          this.customers = customers
          this.totalCount = data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchCustomFields() {
      let params = { page_size: -1 }
      this.$axios.get(`/clinics/${this.company.slug}/patient_custom_fields`, { params })
      .then(resp => {
        const results = resp.data?.results
        if (results) {
          const fields = []
          results.forEach(field => {
            if (field.status === 'active') {
              field.enable = false
              fields.push(field)
            }
          })
          this.$store.commit('clinic/setCustomFields', fields)
        }
      })
      .catch(() => {})
    },
    fetchSegments (isMounted) {
      this.isFetchingSegment = true
      this.segmentTab = 0
      this.segments = [{ id: 'all', title: 'All' }]
      const params = {
        page_size: -1,
        ordering: '-id',
        exclude: 'customer'
      }
      this.$axios.get(`/connect/${this.company.slug}/groups`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.segments = [{ id: 'all', title: 'All' }, ...resp.data.results]
          }
          if (isMounted) {
            this.checkSaveTabFilter()
          } else {
            this.tabChanged()
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingSegment = false
        })
    },
    tabChanged () {
      if (this.segmentTab) {
        this.selectedSegment = this.segments[this.segmentTab]
      } else {
        this.selectedSegment = null
      }
      this.selectedPatients = []
      this.showDynamicFilters = false
      if (this.isMounted) {
        this.fetchCustomers()
      } else {
        this.fetchFirstPage()
      }
      this.checkMenu()
    },
    pageChanged () {
      this.fetchCustomers()
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    checkSaveSearchPage () {
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
    },
    checkSaveTabFilter () {
      if (this.saveTab || this.saveFilters) {
        this.isMounted = true
        if (this.saveTab) {
          this.segmentTab = this.saveTab
          this.selectedSegment = this.segments[this.segmentTab]
        }
        if (this.saveFilters) {
          this.$refs.filter.setFilters()
          this.checkMenu()
        } else {
          this.tabChanged()
        }
         setTimeout(() => {
          this.isMounted = false
        }, 2000)
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    editPatient (item) {
      this.showAddPatientDialog = true
      this.selectedPatient = item
    },
    successDeleteCustomer() {
      this.reset()
    },
    onChecked() {
      this.selectedPatients = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
      this.emitSelectedCustomers()
    },
    onCheckedAll() {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedPatients = this.customers.filter(item => item.checked === true)
      this.emitSelectedCustomers()
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onAddSegment() {
      this.showAddToSegmentDialog = true
    },
    successAddCustomer() {
      this.reset()
    },
    successRemoveSegmentCustomer() {
      this.reset()
    },
    updateDynamicFilter () {
      this.reset()
      this.segments[this.segments.findIndex(f => f.id === this.selectedSegment.id)] = this.selectedSegment
      this.showDynamicFilters = false
    },
    reset () {
      this.checkAll = false
      this.selectedPatients = []
      this.fetchFirstPage()
    },
    closed (action) {
      if (action === 'cancel') {
        // do nothing
      } else if (action === 'add') {
        this.reset()
      } else {
        this.fetchCustomers()
      }
      this.selectedPatient = null
      this.showAddCustomerDialog = false
    },
    openDynamicFilter () {
      this.filters = []
      this.showDynamicFilters = true
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchCustomers()
    },
    onContinue() {
      this.$emit('onContinue', this.selectedPatients)
    },
    emitSelectedCustomers() {
      this.$emit('onSelectedCustomers', this.selectedPatients)
    },
    addContact() {
      this.showAddCustomerDialog = true
    },
    onChanged(i) {
      this.selectedAddContactOption = this.addContactOptions[i]
    },
    confirmAddContact() {
      switch (this.selectedAddContactOption.id) {
        case 'integration':
          alert('Integration')
          break
        case 'csv':
          this.$router.push('/admin/clinic/patients/import')
          break
        case 'single':
          this.showAddPatientDialog = true
          break
      }
    },
    viewPatientInfo (header, item) {
      if (header.value === 'checked' || header.value === 'actions') {
        return
      }
      let route = {
        name: 'ClinicPatientDetails',
        params: {
          id: item.id,
          data: {
            savePage: this.currentPage,
            saveTab: this.segmentTab,
            saveSearch: this.searchText,
            saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
          }
        }
      }
      this.$router.push(route)
    },
    onSendSms () {
      this.$store.commit('donation/selectDonors', this.selectedPatients)
      this.$router.push(`/admin/clinic/patients/send-message`)
    },
    onSendEmail () {
      this.$store.commit('donation/selectDonors', this.selectedPatients)
      this.$router.push(`/admin/clinic/patients/send-email`)
    },
    tabShowMenu (segment) {
      if (segment.id === 'all') {
        return false
      }
      if (this.segments[this.segmentTab].id === segment.id) {
        return true
      }
      return false
    },
    checkMenu () {
      this.showMenu = false
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getFieldData(id, field) {
      const data = field[id]
      if (data) {
        return data
      }
      if (field.custom_data.length) {
        const custom = field.custom_data.find(i => `${i.id}` === id)
        if (custom) {
          if (Array.isArray(custom.value)) {
            return custom.value.join(', ')
          } else if (custom.value && typeof custom.value === 'object') {
            return this.getAddressInString(custom.value)
          }
          return custom.value
        }
      }
      return ''
    },
    getAddressInString (addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
    getAge(date) {
      var today = new Date();
      var birthDate = new Date(date);
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 ||(month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    openWhatsapp (item) {
      const phone = item.phone
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.customers.length - 2
        if (position > start) {
          return true
        }
      }
      return false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    openMergePatientDialog (item) {
      this.selectedPatient = item
      this.showMergeDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  } 
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
.v-tooltip__content {
  top: unset !important;
  left: unset !important;
  position: absolute;
  bottom: 0;
}
</style>